import { Link } from "gatsby"
import React, { ReactElement } from "react"
import InlineCode from "../../components/inlineCode"
import Layout from "../../components/layout"
import { CodeExample } from "../../components/validatorFuncs"

const executeExample1 = `// build a validator
var validator = new ValidatorBuilder<Employee>()
    .Required(e => e.FirstName)
    .For(e => e.LastName, name => 
    {
        name.Required()
            .MaxLength(30);
    })
    .Email(e => e.Email)
    .Range(e => e.Salary, 50000, 100000)
    .LessThanOrEqual(e => e.Commenced, DateTime.Today)
    .Continue(v =>
    {
        v.True(e => e.Active);
    })
    .Build();

// object to validate
var employee = new Employee
{
    FirstName = "Homer",
    Email = "homer@springfieldnuclear.com",
    Salary = 45000
};

// execute the validator
var result = validator.Validate(employee, new ValidationOptions { ThrowWhenInvalid = true });`

function ExecutingValidators(): ReactElement {
  return (
    <Layout>
      <h1>Executing a Validator</h1>
      <p>
        With your validator built via{" "}
        <Link to="/building/validator-builder/">
          <InlineCode code="ValidatorBuilder<T>" />
        </Link>{" "}
        you can now start validating values.
      </p>
      <p>
        A <InlineCode code="Validator<T>" /> is returned from the{" "}
        <InlineCode code="Build()" /> method of{" "}
        <InlineCode code="ValidatorBuilder<T>" />
      </p>
      <hr className="my-6" />
      <h5 className="font-semibold text-sm mb-4">Method</h5>
      <InlineCode
        className="text-sm text-blue-600 bg-blue-100 font-semibold"
        code="Validate(T value, ValidationOptions options = null)"
      />
      <h5 className="font-semibold text-gray-800 text-sm my-4">Returns</h5>
      <InlineCode className="text-sm text-blue-600 bg-blue-100 font-semibold">
        ValidationResult
      </InlineCode>
      <p></p>
      <h5 className="font-semibold text-gray-800 text-sm my-4">
        Example Usage
      </h5>
      <CodeExample
        code={executeExample1}
        label="Building and executing a Validator"
      />
      <hr className="my-6" />
      <h2 className="mt-8">See also</h2>
      <ul className="list">
        <li>
          <Link to="/validation/options/">Validation Options</Link>
        </li>
        <li>
          <Link to="/validation/results/">Validation Results</Link>
        </li>
      </ul>
    </Layout>
  )
}

export default ExecutingValidators
